import { getToken } from "../auth/adalConfig";
import {apiUrl} from './apiConfig';

async function getAuthToken() {
    let token = await getToken();
    let bearerToken = `Bearer ${token}`;
    return bearerToken;
}

export async function simplePOST(url, data) {
    const token = await getAuthToken();
    try {
        const response = await fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json", 
                "Authorization": token
            },
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (error) {
        return null;
    }
}

export async function simpleAuthPUT(url, data) {
    const token = await getAuthToken();
    try {
        const response = await fetch(`${url}`, {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json", 
                "Authorization": token
            },
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (error) {
        return null;
    }
}

export async function simplePUT(url, data) {
    try {
        return fetch(`${url}`, {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            body: data
        });
    }
    catch (error) {
        return null;
    }
}

export async function simpleAuthGET(url) {
    const token = await getAuthToken();

    try {
        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            headers: { 
                "Content-Type": "application/json", 
                "Authorization": token,
            }
        });

        return response.json();
    }
    catch (error) {
        return null;
    }
}

export async function simpleGET(url) {
    try {
        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            headers: { 
                "Content-Type": "application/json",
            }
        });

        return response.json();
    }
    catch (error) {
        return null;
    }
}

export async function fileGET(url) {
    try {
        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
        });

        let fileName = response.url.split("/");
        fileName = decodeURI(fileName[fileName.length - 1].split('?')[0]);
        const blob = await response.blob();

        return {
            file: blob,
            fileName: fileName
        };
    }
    catch (error) {
        return null;
    }
}


// api for submitting files
export async function fileUpload (id, file) {
    const fileName = file.filename;
    const putURL = await getTemporaryUploadUrl(id, fileName);

    return simplePUT(putURL.fileUploadURL, file.file);
}

// in order for the client to submit documents, it must first request a url 
// dynamically generated by the aws-lambda
export async function getTemporaryUploadUrl (id, fileName) {
    const url = `${apiUrl}/api/get-upload-url?fileName=${id}/${fileName}`;

    return simpleGET(url);
}

// api for submitting the form data
export async function formUpload (id, formData) {
    const url = `${apiUrl}/api/submit/${id}`;
    return simplePUT(url, JSON.stringify(formData));
}

// api for updating a form
export async function updateForm (id, formData) {
    const url = `${apiUrl}/api/rfi/${id}`

    return simpleAuthPUT(url, formData);
}

// fetch a forms associated attachments
export async function getAttachments (id) {
    let url = `${apiUrl}/api/get-download-urls?id=${id}`;

    // returns an array of urls to fetch each of the attachments.
    const attachmentURLs = await simpleAuthGET(url)
    .then(response => {
        return response.fileDownloadURLs || [];
    });

    const filesToFetch = attachmentURLs.map(attachmentURL => { return fileGET(attachmentURL)});

    return await Promise.all(filesToFetch);
}